/**
 * @description 序列化一个对象
 * @param {Object} obj 要序列化的对象
 */
const serializeParams = obj => {
  let str = ''
  for (let i in obj) {
    str += `${i}=${obj[i]}&`
  }
  return str.slice(0, str.length - 1)
}

export default serializeParams



// WEBPACK FOOTER //
// ./src/utils/serialize.js